module.exports = __webpack_public_path__ + "static/img/TAKAMAZ.3be53a51.jpg";